namespace TabAurous.Common {
    export interface AcceptReturnForm {
        ReasonId: Serenity.LookupEditor;
        Remark: Serenity.TextAreaEditor;
    }

    export class AcceptReturnForm extends Serenity.PrefixedContext {
        static formKey = 'Common.AcceptReturn';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!AcceptReturnForm.init)  {
                AcceptReturnForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.TextAreaEditor;

                Q.initFormType(AcceptReturnForm, [
                    'ReasonId', w0,
                    'Remark', w1
                ]);
            }
        }
    }
}
